import React from "react";
import { useRoulette } from "../../store/roulette/RouletteContext";
import RouletteLayout from "./RouletteLayout";

const DashboardRoulette = () => {
    const roulette = useRoulette();

    return <RouletteLayout {...roulette} />;
};

export default DashboardRoulette;